import moment from 'moment';

export const platformType = {
  TAOBAO: '淘宝/天猫',
  ALIBABA: '阿里巴巴',
  PDD: '拼多多',
  JD: '京东',
  DOUYIN: '抖音',
  OTHER: '其他'
};
export const orderStatus = {
  UNPAID: '待支付',
  IN: '打单中',
  SUCCESS: '已出单',
  CANCEL: '取消',
  ABNORMAL: '异常'
};
export const billType = {
  RECHARGE: '充值',
  EXPENSE: '消费',
  INCOME: '收入',
  WITHDRAW: '提现',
  MANUAL: '管理员转账',
  REFUND: '退款'
};
export function jsonToArray(json) {
  const array = [];
  for (let key in json) {
    array.push({ name: json[key], value: key });
  }
  return array;
}

// 时间格式化
export function formatDate(data) {
  data = parseFloat(data);
  let momentNum = '';
  if (data && data.toString().length === 10) {
    data = data * 1000;
  }
  if (data && moment(data).isValid()) {
    momentNum = moment(data).format('YYYY-MM-DD HH:mm:ss');
  }
  return momentNum;
}
export function uuid() {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
// 年-月-日，日期格式
export function getDate(data) {
  data = parseFloat(data);
  let momentNum = '';
  if (data && data.toString().length === 10) {
    data = data * 1000;
  }
  if (data && moment(data).isValid()) {
    momentNum = moment(data).format('YYYY-MM-DD');
  }
  return momentNum;
}
//数组去重
export function arrNewSet(arr) {
  for (var i = 0; i < arr.length; i++) {
    var item = arr[i];
    for (var j = i + 1; j < arr.length; j++) {
      if (item.shopName == arr[j].shopName) {
        if (item.type == 'TAOBAO') {
          arr.splice(i, 1);
          i--;
        } else {
          arr.splice(j, 1);
          j--;
        }
      }
    }
  }
  return arr;
}

/** img src 替换 */
export const replaceImage = (target) => {
  return target.replace(/http\:\/\/cache.wodh.cn|http\:\/\/cache.cz01.cn/, 'https://czkj-cache.oss-cn-shenzhen.aliyuncs.com')  
}